import React, { useCallback } from 'react';
import { useField } from 'formik';
import PropTypes from 'prop-types';
import DatePicker from '..';

const DatePickerMemo = React.memo(DatePicker);

const DatePickerCFormik = (props) => {
	const { name, ...rest } = props;
	const [field, meta, helpers] = useField(name);
	const { setValue } = helpers;

	const handleChange = useCallback(
		(date) => {
			setValue(date);
		},
		[setValue],
	);

	if (!name) return 'For TextField connected to Formik name is required!';

	return (
		<DatePickerMemo
			value={field.value}
			onChange={handleChange}
			onBlur={field.onBlur}
			error={(meta.touched || meta.initialTouched) && meta.error}
			{...rest}
		/>
	);
};

DatePickerCFormik.propTypes = {
	...DatePicker.propTypes,
	name: PropTypes.string,
};

export default DatePickerCFormik;
